/**
 * The long runs of a store: the API's `kind`. A comparison and an alignment
 * never run at once: each refuses while the other is out.
 */
export const RUN_KIND = {
  CATALOG: 'catalog',
  STOCK_PREVIEW: 'stock_preview',
  STOCK_ALIGNMENT: 'stock_alignment',
};

/** Where a run stands. */
export const RUN_STATUS = {
  QUEUED: 'queued',
  RUNNING: 'running',
  DONE: 'done',
  FAILED: 'failed',
};

/**
 * The linked products by state: the listing's `status` filter, and the keys
 * the server counts them under (`listings`).
 */
export const LISTING_FILTER = {
  ALL: 'all',
  OK: 'ok',
  ERROR: 'error',
  BLOCKED: 'blocked',
  DISABLED: 'disabled',
  NOT_LOADED: 'not_loaded',
};

/** Where what an alignment receives may be stored: where the floor promises from. */
export const LOAD_ZONES = ['storage', 'picking'];

/** What applying a comparison does to one product: the row's `action`. */
export const ALIGNMENT_ACTION = {
  RECEIVE: 'receive',
  REMOVE: 'remove',
  NONE: 'none',
  SKIP: 'skip',
};

/** The chips over a comparison's rows. */
export const ALIGNMENT_FILTER = {
  ALL: 'all',
  RECEIVE: ALIGNMENT_ACTION.RECEIVE,
  REMOVE: ALIGNMENT_ACTION.REMOVE,
  WARNINGS: 'warnings',
  SKIP: ALIGNMENT_ACTION.SKIP,
};

/** The pages that watch a store. What they watch stops when they go. */
export const STOCK_SYNC_WATCHER = {
  PRODUCTS: 'products',
  INVENTORY: 'inventory',
  LISTINGS: 'listings',
  ALIGNMENT: 'alignment',
};

/** How often a run in progress, and a product on its way to the store, are read again. */
export const RUN_POLL_MS = 3000;
export const PENDING_POLL_MS = 3000;

/** A run still "running" after this lost its worker: the backend frees its lock at the hour. */
export const RUN_WATCH_MAX_MS = 60 * 60 * 1000;

/** The server keeps a push pending five minutes at most. */
export const PENDING_WATCH_MAX_MS = 6 * 60 * 1000;

/** The listing of stores is capped at a hundred a page; a few pages are walked. */
export const CHANNELS_PAGE_SIZE = 100;
export const MAX_CHANNEL_PAGES = 5;

export const STOCK_SYNC_NOTICE = 'stock-sync-notice';

/** The linked products of a store, a page of the inventory. */
export const SHOPIFY_LISTINGS_PATH = '/warehouse/inventory/shopify';

/** Where a comparison is reviewed and applied. */
export const SHOPIFY_ALIGNMENT_PATH = '/warehouse/inventory/shopify/sync';
